import React from "react";
import './shared/assets/css/main.css';
import { BrowserRouter } from "react-router-dom";
import AppBootstrap from "./core/AppBootstrap";
import {
  AuthProvider,
  AppProvider,
  EducationProvider
} from "shared/context";

import { AppearanceProvider } from "shared/appearance";

function Ti() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <AppearanceProvider>
        <AuthProvider>
          <AppProvider>
            <EducationProvider>
              <AppBootstrap />
            </EducationProvider>
          </AppProvider>
        </AuthProvider>
      </AppearanceProvider>
    </BrowserRouter>
  );
}

export default Ti;

